import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaUserEdit } from "react-icons/fa";
import { useGetAllGroupsQuery } from "../Group/groupApislice";
import { useGetUsersQuery } from "../Admin/adminApiSlice";
import { FaUser, FaUsers } from "react-icons/fa";
import debounce from "lodash.debounce";
import {
  useGetAccessDataSourceMutation,
  useUpdateDatabaseAccessMutation,
  useAssignPermissionMutation,
} from "./EditDataSourceSlice";

export default function AccessControl({ onValueChange }) {
  const [selectedPermission, setSelectedPermission] = useState("edit");
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [userPermissions, setUserPermissions] = useState({});
  const [groupPermissions, setGroupPermissions] = useState({});
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dataSourceId = searchParams.get("dataSourceId");
  // console.log(dataSourceId);

  const debouncedAssignPermission = useRef(
    debounce((params) => {
      assignPermission(params);
    }, 800)
  ).current;

  const [assignPermission, { isLoading, isSuccess, isError, error }] =
    useAssignPermissionMutation();

  const {
    data: groups = [],
    isLoading: isGroupsLoading,
    isError: isGroupsError,
  } = useGetAllGroupsQuery();

  const {
    data: users = [],
    isLoading: isUsersLoading,
    isError: isUsersError,
  } = useGetUsersQuery();

  const [
    getAccessDataSource,
    {
      data: accessDataSource = [],
      isLoading: isAccessLoading,
      isError: isAccessError,
    },
  ] = useGetAccessDataSourceMutation();

  useEffect(() => {
    getAccessDataSource(dataSourceId);
  }, [dataSourceId]);

  if (accessDataSource) {
    // console.log(accessDataSource);
  }

  // useEffect(() => {
  //   if (accessDataSource.length) {
  //     const initialUserPermissions = {};
  //     const initialGroupPermissions = {};

  //     accessDataSource.forEach((access) => {
  //       access.allowedUsers?.forEach((user) => {
  //         initialUserPermissions[user] =
  //           access.permission === "publish"
  //             ? 3
  //             : access.permission === "edit"
  //             ? 2
  //             : access.permission === "read"
  //             ? 1
  //             : access.permission === "no access"
  //             ? 0
  //             : 0;
  //       });

  //       access.allowedGroups?.forEach((group) => {
  //         initialGroupPermissions[group] =
  //           access.permission === "publish"
  //             ? 3
  //             : access.permission === "edit"
  //             ? 2
  //             : access.permission === "read"
  //             ? 1
  //             : access.permission === "no access"
  //             ? 0
  //             : 0;
  //       });
  //     });

  //     setUserPermissions(initialUserPermissions);
  //     setGroupPermissions(initialGroupPermissions);
  //   }
  // }, [accessDataSource]);

  useEffect(() => {
    if (accessDataSource.length) {
      const initialUserPermissions = {};
      const initialGroupPermissions = {};

      accessDataSource.forEach((access) => {
        access.allowedUsers?.forEach((user) => {
          initialUserPermissions[user] =
            access.permission === "edit"
              ? 2
              : access.permission === "read"
              ? 1
              : access.permission === "no access"
              ? 0
              : 0;
        });

        access.allowedGroups?.forEach((group) => {
          initialGroupPermissions[group] =
            access.permission === "edit"
              ? 2
              : access.permission === "read"
              ? 1
              : access.permission === "no access"
              ? 0
              : 0;
        });
      });

      setUserPermissions(initialUserPermissions);
      setGroupPermissions(initialGroupPermissions);
    }
  }, [accessDataSource]);

  const handleGroupSliderChange = (groupName, event) => {
    const newPermissionValue = Number(event.target.value);
    setGroupPermissions((prevPermissions) => ({
      ...prevPermissions,
      [groupName]: newPermissionValue,
    }));
    // const newPermission =
    //   newPermissionValue === 3
    //     ? "publish"
    //     : newPermissionValue === 2
    //     ? "edit"
    //     : newPermissionValue === 1
    //     ? "read"
    //     : "no access";

    const newPermission =
      newPermissionValue === 2
        ? "edit"
        : newPermissionValue === 1
        ? "read"
        : "no access";

    // Trigger API call with groupId
    debouncedAssignPermission({
      id: dataSourceId,
      groupId: groupName,
      newPermission,
    });
  };

  const handleSliderChange = (username, event) => {
    const newValue = Number(event.target.value);
    setUserPermissions((prev) => ({
      ...prev,
      [username]: newValue,
    }));

    if (onValueChange) {
      onValueChange(username, newValue);
    }
    // const newPermission =
    //   newValue === 3
    //     ? "publish"
    //     : newValue === 2
    //     ? "edit"
    //     : newValue === 1
    //     ? "read"
    //     : "no access";
    const newPermission =
      newValue === 2 ? "edit" : newValue === 1 ? "read" : "no access";

    // Trigger API call with userId
    debouncedAssignPermission({
      id: dataSourceId,
      userId: username,
      newPermission,
    });
  };

  const filteredGroups = groups.filter((group) =>
    group.groupName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredUsers = users.filter((user) =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const allFilteredItems = [
    ...filteredUsers.map((user) => ({
      id: user.username,
      label: user.username,
      type: "user",
      realId: user._id,
    })),
    ...filteredGroups.map((group) => ({
      id: group.groupName,
      label: group.groupName,
      type: "group",
      realId: group._id,
    })),
  ];

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedItems(
      newSelectAll ? allFilteredItems.map((item) => item.id) : []
    );
  };

  const handleCheckboxChange = (id) => {
    // console.log("Checkbox ID:", id);
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const [
    updateDatabaseAccess,
    {
      isLoading: isUpdating,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
    },
  ] = useUpdateDatabaseAccessMutation();

  const handleSave = async () => {
    const allowedUsers = [];
    const allowedGroups = [];

    selectedItems.forEach((itemId) => {
      const item = allFilteredItems.find((i) => i.id === itemId);
      if (item) {
        if (item.type === "user") {
          allowedUsers.push(item.id);
        } else if (item.type === "group") {
          allowedGroups.push(item.id);
        }
      }
    });

    const payload = {
      id: dataSourceId,
      permission: selectedPermission,
      allowedUsers,
      allowedGroups,
      blockedUsers: [],
      blockedGroups: [],
    };

    try {
      const response = await updateDatabaseAccess(payload).unwrap();
      // console.log("Update Response:", response);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);

      getAccessDataSource(dataSourceId);
    } catch (error) {
      console.error("Error updating database access:", error);
    }
  };

  return (
    <main className="overflow-hidden flex flex-col w-full h-[92vh]">
      <section className="flex flex-col items-start justify-start gap-2 border border-b-0 border-gray-300 h-[65%] w-full">
        <div className="w-full flex items-center justify-between border border-t-0 gap-4 px-2 py-1">
          <div className="flex flex-col items-start justify-start">
            <h2 className="font-semibold text-gray-800">User Permissions</h2>
            <p className="text-gray-600 text-xs">
              Configure and control access levels for users within the console
              to ensure secure and efficient collaboration.
            </p>
          </div>
          <div className="flex items-center justify-end gap-2">
            <button
              className="border border-gray-400 rounded-md px-5 text-[12px] py-1 bg-pink-600 text-white truncate"
              onClick={() =>
                navigate(
                  `/home/dash/rowlevelaccess?dataSourceId=${dataSourceId}`
                )
              }
            >
              Group Row Level Access
            </button>
            <button
              className="border border-gray-400 rounded-md px-5 text-[12px] py-1 bg-blue-950 text-white truncate"
              onClick={() => setShowModal(true)}
            >
              Add User Roles
            </button>
          </div>
        </div>
        <div className="overflow-hidden overflow-y-auto h-full w-full px-2">
          <table className="border w-full border-collapse ">
            <thead className="sticky top-0 bg-white z-10">
              <tr>
                <th className="border-b text-left px-2">User</th>
                <th className="border-b text-center pl-2 pr-[4%]">No Access</th>
                <th className="border-b text-left px-2">Read</th>
                <th className="border-b text-center pl-2 pr-[8%]">Edit</th>
              </tr>
            </thead>

            <tbody>
              {accessDataSource.map((access, index) => (
                <React.Fragment key={index}>
                  {/* Users */}
                  {access.allowedUsers?.map((userName) => (
                    <tr
                      key={`user-${userName}`}
                      className="border-b border-gray-200 hover:bg-gray-50 text-sm p-1"
                    >
                      <td>
                        <div className="flex items-center justify-start gap-2 px-1">
                          <FaUser className="text-gray-600" /> {userName}
                        </div>
                      </td>
                      <td colSpan={3} className="px-10 py-2 text-center">
                        <input
                          type="range"
                          min="0"
                          max="2"
                          step="1"
                          value={userPermissions[userName] || 0}
                          onChange={(e) => handleSliderChange(userName, e)}
                          className={`w-[76%] appearance-none h-4 rounded-lg outline-none cursor-pointer
                ${
                  userPermissions[userName] === 0
                    ? "accessSlider-input"
                    : "slider-input"
                }`}
                        />
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl w-[400px] p-6 shadow-2xl">
            {/* Header */}
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-800">
                Add User/Group Rule
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>

            {/* Search */}
            <input
              type="text"
              placeholder="Search users or groups"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-[95%] border border-gray-300 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />

            {/* Select All */}
            <label className="flex items-center text-sm font-medium mb-2 text-gray-700">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllChange}
                className="mr-2 accent-indigo-600"
              />
              Select All
            </label>

            {/* List */}
            <div className="h-32 overflow-y-auto border border-gray-200 rounded-lg px-3 py-2 text-sm space-y-2 mb-4">
              {allFilteredItems.map((item) => (
                <label
                  key={item.id}
                  className="flex items-center text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                    className="mr-2 accent-indigo-600"
                  />
                  {item.label}
                </label>
              ))}
            </div>

            {/* Permission Dropdown */}
            <select
              value={selectedPermission}
              onChange={(e) => setSelectedPermission(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="read">Viewer</option>
              <option value="edit">Editor</option>
              {/* <option value="publish">Publish</option> */}
              <option value="no access">No access</option>
            </select>

            {/* Messages */}
            {isUpdateError && (
              <div className="text-red-600 text-sm mb-2">
                There was an error saving the data. Please try again.
              </div>
            )}
            {isUpdateSuccess && (
              <div className="text-green-600 text-sm mb-2">
                Data saved successfully.
              </div>
            )}
            {isUpdating && (
              <div className="text-indigo-600 text-sm mb-2">
                Saving data... please wait.
              </div>
            )}

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 text-sm bg-blue-950 text-white rounded-md hover:bg-blue-900 transition"
              >
                {isUpdating ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
